import { Avatar, Dropdown, Flex, MenuProps, Typography } from "antd";
import { FC, useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router";

import { logout, useAuth } from "@/app/AuthProvider";
import { DEFAULT_CUSTOMER_ROUTE, DEFAULT_SETTINGS_ROUTE } from "@/app/Routes";

import ArrowsUpDownIcon from "@/assets/arrows-up-down.svg?react";
import LogoutIcon from "@/assets/logout.svg?react";
//import NotificationIcon from "@/assets/notification.svg?react";
import ImageIcon from "@/assets/image.svg?react";
import SettingsIcon from "@/assets/settings.svg?react";

import { Breadcrumbs } from "@/components/Breadcrumbs";
import { useBreadcrumbs } from "@/components/Breadcrumbs/BreadcrumbsContext";
import { getRouteTitle, TitleMap } from "@/utils/getRouteTitle";

//const MOCK_NOTIFICATION_COUNT = 23;

const titleMap: TitleMap = {
  courses: "Courses",
  dashboard: "Dashboard",
  programs: "Programs",
  users: "Users",
  posts: "Posts",
  notifications: "Custom Notifications",
  "activity-log": "Activity Log",
  reports: {
    title: "Reports",
    subRoutes: {
      programs: "Program Reports",
      courses: "Course Reports",
      users: "User Reports",
    },
  },
};

export const Header: FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const breadcrumbs = useBreadcrumbs();
  const title = useMemo(() => getRouteTitle(pathname, titleMap), [pathname]);
  const { avatar } = useAuth();
  const profileItems: MenuProps["items"] = useMemo(
    () => [
      {
        key: "settings",
        label: (
          <Flex align="center" justify="space-between">
            <span>Settings</span>
            <SettingsIcon />
          </Flex>
        ),
        onClick: () => navigate(DEFAULT_SETTINGS_ROUTE),
      },
      {
        key: "switchToLearning",
        label: (
          <Flex align="center" justify="space-between">
            <span>Switch to Learning</span>
            <ArrowsUpDownIcon />
          </Flex>
        ),
        onClick: () => navigate(DEFAULT_CUSTOMER_ROUTE),
      },
      {
        key: "logout",
        label: (
          <Flex align="center" justify="space-between">
            <span>Logout</span>
            <LogoutIcon />
          </Flex>
        ),
        onClick: logout,
      },
    ],
    [navigate]
  );

  return (
    <Flex rootClassName="header-container" justify="space-between" align="center">
      <Helmet>
        <title>{title ? `CONNECT | ${title}` : `CONNECT`}</title>
        {title && <meta name="description" content={`${title} page`} />}
      </Helmet>

      {!!breadcrumbs.length && <Breadcrumbs breadcrumbs={breadcrumbs} />}

      {title && (
        <Typography.Title level={3} className="header-title">
          {title}
        </Typography.Title>
      )}

      <Flex justify="right" align="center" gap={28}>
        {/*         <Badge count={MOCK_NOTIFICATION_COUNT > 9 ? "9+" : MOCK_NOTIFICATION_COUNT} color="blue">
          <Button className="notification-btn" type="text" icon={<NotificationIcon />} />
        </Badge> */}
        <Dropdown menu={{ items: profileItems }} placement="bottomRight" overlayStyle={{ width: 200 }}>
          {avatar ? <Avatar className="profile-avatar" src={avatar} /> : <Avatar className="profile-avatar" icon={<ImageIcon />} />}
        </Dropdown>
      </Flex>
    </Flex>
  );
};
